import WorkflowOverviewBoardReducer from './workflow_overview_board'

export default function reducer (state = {}, action) {
  return {
    workflowOverviewBoard: WorkflowOverviewBoardReducer(state.workflowOverviewBoard, action)
  }
}